import { Link } from "react-router-dom";
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import JoinMovement from "../../svg/join-movement.svg";
import StepGreatness from "../../svg/step-greatness.svg";
import loginimg1 from "../../assets/assets_html/images/loginimg1.png";
import loginimg2 from "../../assets/assets_html/images/loginimg2.png";
import loginimg3 from "../../assets/assets_html/images/loginimg3.png";
import loginimg4 from "../../assets/assets_html/images/loginimg4.png";

const LeftBase = (props) => {
  const navigate = useNavigate();
  const { backToHomeBtn, type } = props;

  const handleRedirect = (e, path = "/") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  useEffect(() => {
    $(".regisSlider").slick({
      arrows: false,
      dots: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 15000,
      speed: 100,
      fade: true,
    });
  }, []);
  const loginBanners = [loginimg1, loginimg2, loginimg3, loginimg4];

  const randomBanner = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * loginBanners.length);
    return loginBanners[randomIndex];
  }, []);

  return (
    <div>
      <div>
        <p className="text-start mt-3">
          {backToHomeBtn && type !== "Login" && (
            <Link to="/" className="text-white text-decoration-none back-link">
              <u>HOME</u>{" "}
            </Link>
          )}
        </p>

        <img
          src={
            type === "Movement"
              ? JoinMovement
              : type === "Login"
                ? randomBanner
                : StepGreatness
          }
          alt="Join Movement"
          className={
            type === "Login"
              ? "position-absolute top-0 start-0 h-100 w-100"
              : "join-movement w-100"
          }
          style={type === "Login" ? { objectFit: "cover", zIndex: 0 } : {}}
        />

        {type === "Login" && (
          <div
            className="position-absolute w-100 text-center px-3"
            style={{ bottom: "10%", left: 0, zIndex: 1 }}
          >
            <h2
              style={{
                color: "#F8C600",
                fontFamily: "montserrat",
                fontWeight: 600,
                fontSize: "30px",
                marginBottom: "5px",
              }}
            >
              Publish Your Research with Guided Support{" "}
            </h2>
            <p
              style={{
                color: "#ffffff",
                fontFamily: "montserrat",
                fontWeight: 400,
                fontSize: "20px",
                fontStyle: "regular",
                margin: 0,
              }}
            >
              From submission to global visibility—we simplify the entire
              process
            </p>
          </div>
        )}
      </div>

      {type === "Movement" ? (
        <>
          <p className="mission-text">
            We are on a mission to make access to information{" "}
            <i>free as freedom</i> so that it is seamless and connected,
            breaking barriers of exclusion, regionalism and discrimination faced
            by scholars and researchers across the globe.
          </p>
        </>
      ) : (
        type !== "Login" && (
          <p className="mission-text">
            Join us in our mission to make access to information{" "}
            <i>free as freedom</i> so that it is seamless and connected. We
            remain committed to being inclusive, affordable and{" "}
            <span className="f-600">Open for All.</span>
          </p>
        )
      )}
    </div>
  );
};

LeftBase.propTypes = {
  backToHomeBtn: PropTypes.bool,
  type: PropTypes.string,
};

LeftBase.defaultProps = {
  backToHomeBtn: true,
  type: "greatness",
};

export default LeftBase;
